import { render, staticRenderFns } from "./IrrigationForm.vue?vue&type=template&id=653e0328"
import script from "./IrrigationForm.vue?vue&type=script&lang=js"
export * from "./IrrigationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports